import * as tslib_1 from "tslib";
import { AfterViewInit, EventEmitter, OnDestroy } from '@angular/core';
import { AppComponent } from '../app.component';
import { UrlService } from '../model/url.service';
import { UniversalPlatformService } from '../shared/platform/universal-platform.service';
import { FbService } from '../shared/fb.service';
import { AutoUnsubscribe } from '../decorators/autounsubscribe.decorator';
var SocialShareComponent = /** @class */ (function () {
    function SocialShareComponent(urlService, _platformService, _app, _fbService) {
        var _this = this;
        this.urlService = urlService;
        this._platformService = _platformService;
        this._app = _app;
        this._fbService = _fbService;
        this.emailClick = new EventEmitter();
        this._fbLikeEnabled = this._fbShareEnabled = _platformService.isBrowser;
        this._fbRemoveSub = _fbService.fbRemoved.subscribe(function () {
            _this._fbLikeEnabled = false;
        });
        this._fbRefreshedSub = _fbService.fbRefreshed.subscribe(function () {
            _this._fbLikeEnabled = _this._fbShareEnabled = _this._platformService.isBrowser;
            // this._fbService.parse();
        });
        this._fbInitializedSub = _fbService.initialized.subscribe(function (count) {
            if (count > 0) {
                _this._fbLikeEnabled = _this._fbShareEnabled = _this._platformService.isBrowser;
                if (_this._fbInitializedSub) {
                    _this._fbInitializedSub.unsubscribe();
                }
            }
        });
    }
    Object.defineProperty(SocialShareComponent.prototype, "sharedUrl", {
        get: function () {
            if (this.url && (this.url || []).length) {
                return this.url;
            }
            return this.urlService.getCurrentUrl();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SocialShareComponent.prototype, "enableFbLike", {
        get: function () {
            if (this._platformService.isBrowser) {
                return this._fbLikeEnabled;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    SocialShareComponent.prototype.ngAfterViewInit = function () {
        this._fbService.parse();
    };
    SocialShareComponent.prototype.ngOnDestroy = function () {
        if (this._fbInitializedSub) {
            this._fbInitializedSub.unsubscribe();
        }
        this._fbRemoveSub.unsubscribe();
        this._fbRefreshedSub.unsubscribe();
    };
    SocialShareComponent.prototype.onEmailClick = function (evt) {
        if (evt && evt.preventDefault) {
            evt.preventDefault();
        }
        this.emailClick.emit([]);
    };
    SocialShareComponent.prototype.getSocialLink = function (portal, url) {
        var sharedUrl = url && (url || []).length ? url : this.sharedUrl;
        var link;
        switch (portal) {
            case 'facebook':
                link = 'https://www.facebook.com/sharer/sharer.php?u=';
                break;
            case 'twitter':
                link = 'https://twitter.com/home?status=';
                break;
            case 'pinterest':
                link = 'https://pinterest.com/pin/create/button/?media=&description=&url=';
                break;
            case 'googleplus':
                link = 'https://plus.google.com/share?url=';
                break;
            default:
                link = '';
        }
        if (!(link || []).length) {
            return link;
        }
        link += encodeURIComponent(sharedUrl);
        return link;
    };
    SocialShareComponent = tslib_1.__decorate([
        AutoUnsubscribe(),
        tslib_1.__metadata("design:paramtypes", [UrlService,
            UniversalPlatformService,
            AppComponent,
            FbService])
    ], SocialShareComponent);
    return SocialShareComponent;
}());
export { SocialShareComponent };
